import { render } from "./SquaredCard.vue?vue&type=template&id=225a1533"
import script from "./SquaredCard.vue?vue&type=script&lang=js"
export * from "./SquaredCard.vue?vue&type=script&lang=js"

import "./SquaredCard.vue?vue&type=style&index=0&id=225a1533&lang=css"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__